





















































import { Component, Vue, PropSync } from "vue-property-decorator";
import { Getter } from "vuex-class";
import WalletSelector from "./WalletSelector.vue";
import { USDT_ASSET_ID } from "hfox/constants";
import { USDT_ASSET } from "hfox/constants";

@Component({
  components: {
    WalletSelector
  }
})
class WithdrawModal extends Vue {
  @PropSync("visible") dialog!: boolean;

  @Getter("hfox/getBalance") balance!: number;

  amount = "0";

  submitting = false;

  wallet = "";

  get meta() {
    const usdt = {
      ...USDT_ASSET,
      precision: 2
    };
    const legalAmount = this.$common.utils.currency.fiat(this, {
      from: "USD",
      value: this.amount
    });
    const amount = Number(this.amount);
    const valid = amount && amount > 0 && amount <= this.balance;
    return {
      usdt,
      valid,
      symbol: usdt.symbol,
      legalAmountText: legalAmount && `≈${legalAmount}`,
      assets: [usdt]
    };
  }

  get rules() {
    const balance = this.balance;
    return {
      amount: [
        v => !!v || this.$t("common.amount.required"),
        v => {
          if (Number(v) <= 0) {
            return this.$t("common.amount.invalid");
          }
          if (Number(v) > Number(balance)) {
            return this.$t("common.balance.inffrence");
          }
          return true;
        }
      ]
    };
  }

  mounted() {
    const isMixin = this.$common.utils.helper.isMixin();
    if (isMixin) {
      this.wallet = "mixin";
    } else {
      const accountProfile = this.$store.state.basis.account.profile;
      const foxonePinSet = accountProfile?.foxone?.is_pin_set ?? false;
      const foxoneMigrateRequired =
        accountProfile?.foxone_migrate_required ?? false;
      if (foxonePinSet && !foxoneMigrateRequired) {
        this.wallet = "foxone";
      }
    }
  }

  handleWalletChange(value) {
    this.wallet = value;
  }

  async handleWithdraw() {
    const form: any = this.$refs.form;
    const valid = form.validate();
    if (!this.wallet) {
      this.$common.utils.helper.toast(this, {
        message: this.$t("hfox.withdraw.wallet-required") as string,
        color: "error"
      });
      return;
    }
    if (valid) {
      this.submitting = true;
      await this.requestWithdraw(this.amount);
      this.submitting = false;
    }
  }

  async requestWithdraw(amount) {
    try {
      await this.$api.hfox.requestWithdraw(USDT_ASSET_ID, amount, this.wallet);
      this.$common.utils.helper.toast(this, {
        message: this.$t("common.withdraw.request.success") as string,
        color: "success"
      });
      this.dialog = false;
      this.$emit("refresh");
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
    }
  }
}
export default WithdrawModal;
